import React, {useEffect, useState, useRef} from 'react';
import '../App.css';
import { Button } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import Bodyheaderloged from './bodyheaderloged'
import Axios from 'axios';
import { useNavigate } from "react-router-dom";


function Bodyhomeadmin (){    
    const navigate = useNavigate();
    const [administradores, setAdministradores] = useState([]);
    const [empresas, setEmpresas] = useState([]);
    const [casinos, setCasinos] = useState([]);
    const [perfil, setPerfil] = useState()
    const searchInput = useRef();
    let statuscall = '' 
    

    const administradoresList = administradores.map((item, i) => 
    <option key={i} value={item.mail}>{item.nombre} {item.apellido}</option>);


    const empresasList = empresas.map((item, i) => 
    <option key={i} value={item.rut}>{item.nombre}</option>);
    
    const casinosList = casinos.map((item, i) =>
    <option key={i} value={item.id}>{item.nombre}</option>);



    const getData = async () =>
    {
        let mailstr = window.localStorage.getItem('MY_APP_STATE_USER').replace('"', '')
        let idperfilstr = window.localStorage.getItem('MY_APP_STATE_PROF_ID').replace('"', '')
        let idcasinostr = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID').replace('"', '')
        
        let mail = mailstr.replace('"', '')
        let idperfil = idperfilstr.replace('"', '')
        let idcasino = idcasinostr.replace('"', '')

        setPerfil(idperfil.replace('"', ''))

        Axios.get(process.env.REACT_APP_DATAUSER, {
            params: {
                mail: mail, 
                id_perfil: idperfil, 
                id_casino: idcasino,
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            if(idperfil === "4")
            {
                setAdministradores(response.data.administradores)
                setEmpresas(response.data.empresas)
                setCasinos(response.data.casinos)
            }
        }).catch(error => {
            return error     
        })   
    }

    useEffect(() => {  
        getData()

    }, [])


    return (
        <div className='sshbodyappContainerLogin'>
            <div className='sshbodyappContainerRegister'>
                <Bodyheaderloged/>
            </div>
            <div className='sshbodyappContainerLoginForm'>
                <div className='container'>
                    <div className='row'>
                        <div className='col col-lg-6 col-md-6 col-sm-12'>
                            Administradores    
                        </div>
                        <div className='col col-lg-6 col-md-6 col-sm-12'>
                            <select>
                                {administradoresList}
                            </select>
                        </div>
                    </div>
                            
                    <div className='row'>
                        <div className='col col-lg-6 col-md-6 col-sm-12'>
                           Casinos 
                        </div>
                        <div className='col col-lg-6 col-md-6 col-sm-12'>
                            <select>
                                {casinosList}
                            </select>                                
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col col-lg-6 col-md-6 col-sm-12'>
                           Empresas 
                        </div>
                        <div className='col col-lg-6 col-md-6 col-sm-12'>
                            <select>
                                {empresasList}
                            </select>                                
                        </div>
                    </div>
                                                                        
                </div>
            </div>
        </div>            
    )
}
export default Bodyhomeadmin